import { http } from "../http";
import axios from "axios";

export const getUserDetails = async () => {
  try {
    const response = await http.get(`/api/session`);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const dismissSystemNotification = async (notification, user_id) => {
  try {
    const result = await axios.post(
      `/notifications/dismiss_manual_coded_notification/${user_id}`,
      { name: notification.notification_name }
    );
    return result.data;
  } catch (ex) {
    console.log(ex);
  }
};
